import { isSupportedCountry, type Country } from "react-phone-number-input";
import { useOrganization } from "@/contexts/OrganizationContext";

/**
 * The organization's country as the phone inputs' default calling code.
 * `organizations.country` is a nullable ISO-3166 alpha-2 code; anything the
 * phone library doesn't know yields `undefined`, which leaves PhoneInput on
 * its own default.
 */
export function useOrgPhoneCountry(): Country | undefined {
  const { selectedOrganization } = useOrganization();
  const code = selectedOrganization?.country?.trim().toUpperCase();
  return code && isSupportedCountry(code) ? code : undefined;
}
